<template>
  <div>
    <!-- ヘッダ -->
    <comVFHeaderAuth :propScreenTitle="screenTitle" :propSrcScreenId="screenId" :propMenuInfo1="username" :propMenuInfo2="companyName"></comVFHeaderAuth>
    <!-- メイン -->
    <v-main>
      <v-container fluid class="pt-2">
        <br/>
        <!-- 申請者情報 -->
        <!-- <v-row justify="center" align-content="center"> -->
        <v-card outlined tile color="green lighten-1" style="border-width: 2px;" class="rounded-lg">
          <v-row justify="center" align-content="center" class="mt-2">
            <v-col cols="1">
              <v-card outlined tile height="100" color="green lighten-1" style="border: 2px solid white !important;" class="white--text">
                <v-row dense style="height: 30px;">
                  <v-col cols="12" class="d-flex align-center justify-start" >
                    <p><small>確認状態</small></p>
                  </v-col>
                </v-row>
                <v-row dense style="height: 70px;">
                  <v-col cols="12" class="d-flex align-center justify-center" >
                    <p class="text-h5">{{ verifyStatus }}</p>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="1"></v-col>
            <v-col cols="2" class="px-3">
              <v-row no-gutters>
                <v-col style="height: 30px;">
                  <p>氏名&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;：{{ name }}</p>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col style="height: 30px;">
                  <p>性別：{{ sex }}</p>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col style="height: 30px;">
                  <p>生年月日：{{ birthday }}</p>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="2" class="px3">
              <v-row no-gutters>
                <v-col style="height: 30px;">
                  <template v-if="originReceiptNo == ''">
                  <p>受付番号：<span class="text-h5">{{ receiptNo }}</span></p>
                  </template>
                  <template v-else>
                    <p>受付番号：<span class="text-h5">{{ receiptNo }}（{{ originReceiptNo }}）</span></p>
                  </template>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col style="height: 30px;">
                  <p>受付日時：{{ receiptDate }}</p>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col style="height: 30px;">
                  <p>申請日時：{{ appDate }}</p>
                </v-col>
              </v-row>
            </v-col>
            
            <v-col cols="2">
              <v-card outlined tile height="100" color="#FFF9C4" style="border-width: 2px;" >
                <v-row dense style="height: 10px;" class="pl-3">
                  <v-col cols="12" class="d-flex align-center justify-start mb-0">
                    <p><small>決裁</small></p>
                  </v-col>
                </v-row>
                <v-row dense style="height: 50px;">
                  <v-col cols="1"></v-col>
                  <v-col cols="11" class="d-flex align-center justify-center mb-0" >
                    <span class="text-h4">{{ dealName }}</span>
                    <template v-if="reAppFlg">
                      <v-img src="@/assets/img/hanko-re-app.png" style="opacity: 0.7;" height="60" aspect-ratio="1.4" contain></v-img>
                    </template>
                    <template v-else-if="cancelAppFlg">
                      <v-img src="@/assets/img/hanko-cancel.png" style="opacity: 0.7;" height="60" aspect-ratio="1.4" contain></v-img>
                    </template>
                    <template v-else-if="approvalAppFlg">
                      <v-img src="@/assets/img/hanko-ketsu.png" style="opacity: 0.7;" height="60" aspect-ratio="1.4" contain></v-img>
                    </template>
                  </v-col>
                </v-row>
                <v-row dense style="height: 20px;" class="pl-3">
                  <v-col cols="12" class="d-flex align-start justify-start pt-0" >
                    <span><small>{{ approvalDatetime }}</small></span>
                  </v-col>
                </v-row>
                <v-row dense style="height: 10px;" class="pl-3">
                  <v-col cols="12" class="d-flex align-end justify-left pt-0" >
                    <span><small>{{ approvalName }}</small></span>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="3" class="pt-0">
                <v-data-table 
                  dense
                  :headers="historyHeaders" 
                  :items="historyDesserts"
                  item-key="branchNo"
                  :items-per-page='2'
                           
                  class="v-data-table elevation-1 v-dtbl-md-1 v-dtbl-body-sm-1"
                  :no-data-text="$t('webmsg.VFV210.datatblenodata2')"
                >
                  <template v-slot:[`item.showDetailFlg`]="{ item }">
                    <template v-if="item.showDetailFlg">
                      <v-btn small color="success" dark min-width="80px" elevation="5" @click="dispConfirmView(item.receiptNo)">{{ $t("LCM005") }}</v-btn>
                    </template>
                  </template>
                </v-data-table>
            </v-col>
          </v-row>
        </v-card>
        <br/>

        <v-row>
          <v-col cols="6" class="pb-0">
            <p class="mb-0">申請書類：{{appDocKbnName}} </p>
          </v-col>
          <v-col cols="6" class="d-flex align-center justify-end pb-0">
            <p class="mb-0">有効期間：{{validityperiodEndDatetime}}まで</p>
          </v-col>
        </v-row>
        <v-row justify="center" align-content="center">
          <!-- 画像エリア(書類) -->
          <v-col cols="3">
            <v-tabs show-arrows v-model="tabNo1" active-class="blue lighten-4">
              <v-tab v-for="item in docPhotoList" :key="item.docDetailKbn">
                {{item.docDetailKbnName}}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabNo1">
              <v-tab-item v-for="item in docPhotoList" :key="item.docDetailKbn">
                <v-card flat outlined tile style="border-width: 2px;">
                   <v-img :src="item.fileData" max-width="auto" height="40vh"></v-img>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
          <!-- 画像エリア(顔) -->
          <v-col cols="3">
            <v-tabs show-arrows v-model="tabNo2" active-class="blue lighten-4">
              <v-tab v-for="item in facePhotoList" :key="item.docDetailKbn">
                {{item.docDetailKbnName}}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabNo2">
              <v-tab-item v-for="item in facePhotoList" :key="item.docDetailKbn">
                <v-card flat outlined tile style="border-width: 2px;">
                   <v-img :src="item.fileData" max-width="auto" height="40vh"></v-img>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
          <!-- 処置履歴エリア -->
          <v-col cols="6">
            <v-row>
              <v-col cols="12">
                <p class="text-h6">処置履歴</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-data-table 
                  :headers="headers" 
                  :items="desserts"
                   item-key="no"
                  :items-per-page="5"
                  show-expand 
          
                  class="v-data-table elevation-1 v-dtbl-md-1"
                  :no-data-text="$t('webmsg.VFV210.datatblenodata')"
                >
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" style="background-color: #FFE0B2 !important;" >
                    <span v-html="item.comment"></span>
                    </td>
                  </template>
                  <template v-slot:[`item.approverFlg`]="{ item }">
                    <v-simple-checkbox v-model="item.approverFlg" disabled></v-simple-checkbox>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        
        <v-row style="height: 1vh;"></v-row>

        <v-card class="" color="light-green lighten-4" max-height="150px">
          <v-row justify="center" align-content="center" class="">

            <v-col cols="1" class="white--text">
              <v-btn class="text-subtitle-1" color="blue-grey darken-1" dark width="120px" height="120px" elevation="24" @click="reAppRequest()" v-show="canReApp">
                    <!-- <v-icon left large>mdi-email-fast-outline</v-icon>  -->
                    再申請依頼
              </v-btn>
            </v-col>

            <v-col cols="1" class="white--text">
              <v-btn large class="text-subtitle-1" color="blue-grey darken-1" dark width="120px" height="120px" elevation="24" @click="cancel()" v-show="canRequestCancel">
                    <!-- <v-icon left large>mdi-cancel</v-icon>  -->
                    依頼取消
              </v-btn>
            </v-col>

            <!-- <v-col cols="1"></v-col> -->
            <!-- コメントエリア -->
            <v-col cols="1" class="pr-0">
              <v-sheet color="grey lighten-3" min-height="80%" class="d-flex align-center justify-center" elevation="1" outlined>コメント</v-sheet>
            </v-col>
            <v-col cols="6" class="pl-0">
              <v-textarea outlined id="textarea" v-model="inputCommentInfo" rows="4" overflow="scroll" no-resize background-color="white"></v-textarea>
            </v-col>
            <!-- <v-col cols="1"></v-col> -->
            <!-- ボタンエリア -->
            <v-col cols="1" class="white--text">
              <v-btn large class="text-subtitle-1" color="blue darken-2" width="120px" height="120px" elevation="24" @click="approval()" :disabled ="!canApproval">
                <!-- <v-icon left large>mdi-check-decagram-outline</v-icon> -->
                承認する
              </v-btn>
            </v-col>

            <v-col cols="1" class="white--text">
              <v-btn large class="text-subtitle-1" color="red darken-2" width="120px" height="120px" elevation="24" @click="deny()" :disabled ="!canApproval">
                <!-- <v-icon left large>mdi-exclamation</v-icon> -->
                否認する
              </v-btn>
            </v-col>
            
          </v-row>
        </v-card>
        <!-- 戻るボタンエリア -->
        <v-row justify="center" align-content="center" class="mt-1">
          <v-col cols="12" class="d-flex align-center justify-end">
            <v-btn x-large color="green lighten-1" dark min-width="200px" @click="back()">戻る</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <comMessage :msg="dlgMsg.msg" :isOpen="dlgMsg.isOpen" :doYes="dlgMsg.doYes"/>
    <comMessage :msg="dlgMsgCompd.msg" :isOpen="dlgMsgCompd.isOpen" :doYes="dlgMsgCompd.doYes"/>
    <comMessageConfirm :msg="dlgCancelMsgConfirm.msg" :isOpen="dlgCancelMsgConfirm.isOpen" :doYes="dlgCancelMsgConfirm.doYes" :doNo="dlgCancelMsgConfirm.doNo" />
    <comMessageConfirm :msg="dlgReAppMsgConfirm.msg" :isOpen="dlgReAppMsgConfirm.isOpen" :doYes="dlgReAppMsgConfirm.doYes" :doNo="dlgReAppMsgConfirm.doNo" />
  </div>
</template>
<script>
import Constants from '../common/constantsVf';
import Utils from '../common/utils';
export default {
  name: "VFAppDetailsViewDeal",
  data() {
    return {
      screenTitle: "申請詳細表示処置",
      screenId: "VFV210",
      userName: "",
      companyName: "",
      verifyStatus:"",
      name:"",
      sex:"",
      birthday:"",
      receiptNo: "",
      originReceiptNo: "",
      receiptDate:"",
      appDate:"",
      dealName:"",
      approvalDatetime:"",
      approvalName:"",
      tabNo1: 0,
      tabNo2: 0,
      docPhotoList: [],
      facePhotoList: [],
      docDetailKbnList: [],
      inputCommentInfo: "",
      canApproval: false,
      canRequestCancel: false,
      canReApp: false,
      reAppFlg: false,
      cancelAppFlg: false,
      approvalAppFlg: false,
      appRequestUpdateDatetime: "",
      appRequestUpdateUserId: "",
      validityperiodEndDatetime: "",
      appDocKbnName: "",
      headers: [
          { text: "No", align: "start", value: "no", width: "10%" },
          { text: '処置', align: 'start', sortable: true, value: 'deal', width: "12%" },
          { text: '決裁者', align: 'center', sortable: true, value: 'approverFlg', width: "12%" },
          { text: '処置者', align: 'start', sortable: true, value: 'dealUserName', width: "" },
          { text: '処置日時', align: 'center', sortable: true, value: 'dealDatetime', width: "30%"},
          { text: 'コメント', align: 'start', sortable: true, value: 'data-table-expand', width: "16%" },
      ],
      desserts: [],
      historyHeaders: [
          { text: "No", align: "center", sortable: false, value: "no", width: "10%" },
          { text: '受付番号', align: 'center', sortable: false, value: 'receiptNo', width: "30%" },
          { text: '申請依頼日', align: 'center', sortable: false, value: 'dispRequestDate', width: "" },
          { text: '詳細', align: 'center', sortable: false, value: 'showDetailFlg', width: "10%" },
      ],
      historyDesserts: [],
      dlgMsg: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsg.isOpen = false;
        },
      },
      dlgMsgCompd: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.getAppDealHistory(this.receiptNo);
          this.dlgMsgCompd.isOpen = false;
        },
      },
      dlgCancelMsgConfirm: {
        msg: this.$i18n.t('msg.wrn.vfv011'),
        isOpen: false,
        doYes: () => {
          this.cancelVerifyAppRequest();
          this.dlgCancelMsgConfirm.isOpen = false;
        },
        doNo: () => {
          this.dlgCancelMsgConfirm.isOpen = false;
        },
      },
      dlgReAppMsgConfirm: {
        msg: this.$i18n.t('msg.wrn.vfv012'),
        isOpen: false,
        doYes: () => {
          this.reVerifyAppRequest();
          this.dlgReAppMsgConfirm.isOpen = false;
        },
        doNo: () => {
          this.dlgReAppMsgConfirm.isOpen = false;
        },
      },
    };
  },

  created() {
    this.initialize();
  },
  beforeRouteLeave(to, from, next) {
    if (to.name != 'VFV200') {
      this.$store.commit("vfReceiptAppListSearch/resetState");
    }
    next();
  },
  methods: {
        /**
     * 詳細画面遷移
     */
    dispConfirmView(receiptNo) {
      // this.$router.push(this.$router.resolve({ name: "VFV210", params: {receiptNo: receiptNo, srcScreenId: 'VFV100'} }).href);
      this.initialize(receiptNo);
    },
    /*
    * 初期表示
    */
    initialize: function(receiptNo) {
      this.setAuthUserInfo();

      if (receiptNo == '' || typeof receiptNo === "undefined") {
        this.receiptNo = this.$route.params.receiptNo;
      } else {
        this.receiptNo = receiptNo;
      }
      this.docDetailKbnList =  this.$store.getters["vfMaster/getDocDetailKbnList"];
      if (Utils.isNullOrEmptyOrUunDef(this.receiptNo)) {
        this.back();
      }
      this.getAppDealHistory(this.receiptNo);
    },
    /*
    * 承認ボタン押下
    */
    approval: function() {
      let reqData = {};
      reqData['receiptNo'] = this.receiptNo;
      reqData['dealKbn'] = Constants.DEAL_KBN_APPROVAL;
      reqData['dealComment'] = this.inputCommentInfo;
      reqData['appRequestUpdateDatetime'] = this.appRequestUpdateDatetime;
      reqData['appRequestUpdateUserId'] = this.appRequestUpdateUserId;
      this.dealWithVerifyApp(reqData);
    },
    /*
    * 否認ボタン押下
    */
    deny: function() {
      let reqData = {};
      reqData['receiptNo'] = this.receiptNo;
      reqData['dealKbn'] = Constants.DEAL_KBN_DENIAL;
      reqData['dealComment'] = this.inputCommentInfo;
      reqData['appRequestUpdateDatetime'] = this.appRequestUpdateDatetime;
      reqData['appRequestUpdateUserId'] = this.appRequestUpdateUserId;
      this.dealWithVerifyApp(reqData);
    },
    /*
    * 依頼取消ボタン押下
    */
    cancel: function() {
      this.dlgCancelMsgConfirm.isOpen = true;
    },
    /*
    * 再申請ボタン押下
    */
    reAppRequest: function() {
      this.dlgReAppMsgConfirm.isOpen = true;
    },
    reVerifyAppRequest: async function() {
      let data = {};
      data['receiptNo'] = this.receiptNo;
      data['dealKbn'] = "";
      data['dealComment'] = this.inputCommentInfo;
      data['appRequestUpdateDatetime'] = this.appRequestUpdateDatetime;
      data['appRequestUpdateUserId'] = this.appRequestUpdateUserId;

      let responseData = null;
      let apiErrorInfo = null;
      let apiurl = Constants.getUrlApiVFV210P02(this.receiptNo);
      let accessToken = this.$store.getters["vfAuthcUser/getAccessToken"];

      try {
        let response = await this.$axios.post(apiurl, data, 
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "json",
            });
        responseData = response.data;
      } catch(error) {
         apiErrorInfo = error;
      }
      // 完了メッセージ表示 
      this.showDialogMsgAfterAPICall(apiErrorInfo, responseData);
    },
    /*
    * 戻るボタン押下
    */
    back: function() {
      let srcScreenId = this.$route.params['srcScreenId'];
      if (srcScreenId == null) { 
        this.$router.push(this.$router.resolve({ name: "VFV100" }).href);
      } else {
         this.$router.push(this.$router.resolve({ name: srcScreenId }).href);
      }
    },
    dealWithVerifyApp: async function(data) {
      
      let responseData = null;
      let apiErrorInfo = null;
      let apiurl = Constants.getUrlApiVFV210P01(data.receiptNo);
      let accessToken = this.$store.getters["vfAuthcUser/getAccessToken"];

      try {
        let response = await this.$axios.post(apiurl, data, 
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "json",
            });
        responseData = response.data;
      } catch(error) {
         apiErrorInfo = error;
      }
      // 完了メッセージ表示
      this.showDialogMsgAfterAPICall(apiErrorInfo, responseData);
    },
    cancelVerifyAppRequest: async function() {

      let data = {};
      data['receiptNo'] = this.receiptNo;
      data['dealKbn'] = "";
      data['dealComment'] = this.inputCommentInfo;
      data['appRequestUpdateDatetime'] = this.appRequestUpdateDatetime;
      data['appRequestUpdateUserId'] = this.appRequestUpdateUserId;
      
      let responseData = null;
      let apiErrorInfo = null;
      let apiurl = Constants.getUrlApiVFV210D01(data.receiptNo);
      let accessToken = this.$store.getters["vfAuthcUser/getAccessToken"];
      try {
        let response = await this.$axios.post(apiurl, data, 
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "json",
            });
        responseData = response.data;
      } catch(error) {
         apiErrorInfo = error;
      }
      // 完了メッセージ表示 
      this.showDialogMsgAfterAPICall(apiErrorInfo, responseData);
    },

   /*
    * 完了メッセージ表示
    */
    showDialogMsgAfterAPICall : function(apiErrorInfo, responseData) {
      let hasError = true;
      // APIコール異常
      if (responseData == null || apiErrorInfo != null) {
        this.dlgMsg.msg = this.$i18n.t('msg.err.cm111', ['処置履歴']);
        this.dlgMsg.isOpen = true;
        return hasError;
      }
      // APIコール正常
      if (responseData.statusCd === 200) {
        // 処理正常
        hasError = false;
        this.dlgMsgCompd.msg = responseData.message ;
        this.dlgMsgCompd.isOpen = true;
        return hasError;
      } else {
        // 処理異常
        let errorList = responseData.errorList;
        if (errorList != null && errorList.length > 0) {
          this.dlgMsg.msg = Utils.createMsgViewStringForErrList(errorList);
          this.dlgMsg.isOpen = true;
          return hasError;
        } else {
          this.dlgMsg.msg = responseData.message ;
          this.dlgMsg.isOpen = true;
          return hasError;          
        }
      }
    },

    /*
    * 本人確認依頼・申請・処置履歴取得
    */
    getAppDealHistory : async function(receiptNo) {
      this.desserts = [];
      this.historyDesserts = [];
      this.docPhotoList = [];
      this.facePhotoList = [];
      let responseDto = null;
      this.tabNo1 = 0;
      this.tabNo2 = 0;
      let apiurl = Constants.getUrlApiVFV210G01(receiptNo);
      let accessToken = this.$store.getters["vfAuthcUser/getAccessToken"];

      try {
        let response = await this.$axios.get(apiurl, 
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "json",
            });

        responseDto = response.data;
        this.displyResponseData(responseDto);
        this.dispSearchDataForFileInfo(receiptNo);
      } catch(error) {
         this.dlgMsg.msg = this.$i18n.t('msg.err.cm100', ['申請詳細表示処置']);
         this.dlgMsg.isOpen = true;
         this.desserts.push({});
         this.historyDesserts.push({});
      } finally {
        this.loading = false;
        this.datatableLoading = false;
      }
    },
    sleep: function(waitMsec) {
      var startMsec = new Date();
      // 指定ミリ秒間だけループさせる（CPUは常にビジー状態）
      while (new Date() - startMsec < waitMsec);
    },
    dispSearchDataForFileInfo: async function(receiptNo) {
        await this.getFileInfo(receiptNo, Constants.APP_DOCUMENT_DETAIL_FRONT);
        await this.getFileInfo(receiptNo, Constants.APP_DOCUMENT_DETAIL_FACE_FRONT);
        await this.getFileInfo(receiptNo, Constants.APP_DOCUMENT_DETAIL_DIAGOBAL);
        await this.getFileInfo(receiptNo, Constants.APP_DOCUMENT_DETAIL_BACK);
        await this.getFileInfo(receiptNo, Constants.APP_DOCUMENT_DETAIL_FACE_DIAGOBAL);
        this.tabNo1 = 0;
        this.tabNo2 = 0;

    },
    /*
    * ファイル情報取得・表示
    */
    getFileInfo : async function(receiptNo, docDetailKbn) {

      let apiurl = Constants.getUrlApiVFV210G02(receiptNo, docDetailKbn);
      let accessToken = this.$store.getters["vfAuthcUser/getAccessToken"];
      try {
        let response = await this.$axios.get(apiurl, 
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "blob",
            });
        // 申込済情報表示
        if (response.data != null) {
          // this.dispPdfFileBlobUrl = window.URL.createObjectURL(response.data);
          let photo = {};
          photo['docDetailKbn'] = docDetailKbn;
          photo['docDetailKbnName'] =  this.searchKbnNameByValue1Mixin(this.docDetailKbnList, docDetailKbn);
          photo['fileData'] =  window.URL.createObjectURL(response.data);
          if (Constants.APP_DOCUMENT_DETAIL_FRONT == docDetailKbn) {
            this.docPhotoList.splice(0, 0, photo);
          } else if (Constants.APP_DOCUMENT_DETAIL_DIAGOBAL == docDetailKbn) {
            this.docPhotoList.splice(1, 0, photo);
          } else if (Constants.APP_DOCUMENT_DETAIL_BACK == docDetailKbn) {
            this.docPhotoList.splice(2, 0, photo);
          }
          if (Constants.APP_DOCUMENT_DETAIL_FACE_FRONT == docDetailKbn) {
            this.facePhotoList.splice(0, 0, photo);
          } else if (Constants.APP_DOCUMENT_DETAIL_FACE_DIAGOBAL == docDetailKbn) {
            this.facePhotoList.splice(1, 0, photo);
          }
        }
      } catch(error) {
         this.dlgMsg.msg = this.$i18n.t('msg.err.cm100', ['申請詳細表示処置']);
         this.dlgMsg.isOpen = true;
         this.desserts.push({});
         this.historyDesserts.push({});
      }
      return;
    },

    displyResponseData: function(responseDto) {
      if (responseDto == null || responseDto.data == null) {
        return;
      }
      let searchData = responseDto.data;
      this.appRequestUpdateDatetime = searchData.appRequestUpdateDatetime;
      this.appRequestUpdateUserId = searchData.appRequestUpdateUserId;
      this.verifyStatus = searchData.verifyStatusKbnName;
      this.name = searchData.appName;
      this.sex = searchData.appSex;
      this.birthday = searchData.displayAppBirthday;
      this.receiptNo = searchData.receiptNo;
      this.originReceiptNo = searchData.originReceiptNo;
      this.receiptDate = searchData.displayReceiptDatetime;
      this.appDate = searchData.displayAppDatetime;
      this.dealName = searchData.displayApprovalDealKbnName;
      this.approvalDatetime = searchData.displayApprovalDatetime;
      this.approvalName = searchData.approvalName;
      this.canApproval = searchData.canApproval;
      this.canRequestCancel = searchData.canRequestCancel;
      this.validityperiodEndDatetime = searchData.displayValidityperiodEndDatetime;
      this.canReApp = searchData.canReApp;
      this.reAppFlg = searchData.reAppFlg;
      this.cancelAppFlg = searchData.cancelAppFlg;
      this.approvalAppFlg = searchData.approvalAppFlg;
      this.appDocKbnName = searchData.appDocKbnName;

      // 処置履歴
      this.displayDealHistory(searchData.verifyDealWithHistoryExList);
      // 申請依頼履歴
      this.displayAppRequestHistory(searchData.verifyAppReqestHistoryList);
      this.inputCommentInfo = searchData.inputComment;
    },
    displayDealHistory: function(dealHistory) {
      if (Utils.isEmptyArry(dealHistory)) {
        return;
      } 
      let data;
      for (const value of dealHistory) {
        data = {};
        data['no'] = value.no;
        data['dealUserName'] = value.dealUserName;
        data['approverFlg'] = value.approverFlg;
        data['deal'] = value.dealKbnName;
        data['dealDatetime'] = value.displayDealDatetime;
        data['comment'] = Utils.nl2br(value.dealComment);
        this.desserts.push(data);
      }
    },
   displayAppRequestHistory: function(appRequestHistory) {
      if (Utils.isEmptyArry(appRequestHistory)) {
        return;
      } 
      let data;
      for (const value of appRequestHistory) {
        data = {};
        data['no'] = value.branchNo;
        data['receiptNo'] = value.receiptNo;
        data['dispRequestDate'] = value.dispRequestDate;
        data['showDetailFlg'] = value.showDetailFlg;
        this.historyDesserts.push(data);
      }
    },

    setAuthUserInfo : function() {      
      let authInfo = this.setVerifyLoginInfoVfMixin();
      this.username = authInfo['username'];
      this.companyName = authInfo['companyname'];
    },
    
  },
}
</script>
<style scoped>

.tab-title {
  justify-content: left;
  }

img {
  max-width: 100%;
}

.image {
  height: 100%;
}

</style>